"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoltAbilityHandler = exports.JoltActorAbilityFactory = exports.JoltAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorType_1 = require("../../core/actors/ActorType");
const Record_1 = require("../../utils/Record");
const Enum_1 = require("../../utils/Enum");
class JoltAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Jolt;
        this.__typeName = "Jolt";
    }
}
exports.JoltAbilityArgs = JoltAbilityArgs;
let JoltActorAbilityFactory = class JoltActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Jolt", "OneEnemies", 1);
    }
};
JoltActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Jolt")
], JoltActorAbilityFactory);
exports.JoltActorAbilityFactory = JoltActorAbilityFactory;
let JoltAbilityHandler = class JoltAbilityHandler {
    constructor() {
        this.crystalDamages = {
            "None": "Chaos",
            "Magician_FireCrystal": "Fire",
            "Magician_FrostCrystal": "Frost",
            "Magician_NatureCrystal": "Nature",
            "Magician_SonicCrystal": "Sonic",
        };
        this.crystalProjectiles = {
            "None": "ArcaneBolt",
            "Magician_FireCrystal": "FireBolt",
            "Magician_FrostCrystal": "Frost",
            "Magician_NatureCrystal": "GreenOrb",
            "Magician_SonicCrystal": "CyanHauntedProjectile",
        };
    }
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const selfId = container.getActor(ability.invokerId).ownerId || ability.invokerId;
        container.applyProjectileAttacksWithDamage({
            sequence: sequence.pushSequence("parallel"),
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: Array.of(selfId, ...container.getSummonedCompanions(selfId))
                .map(originId => {
                const originType = (0, Enum_1.enumKey)(ActorType_1.ActorType, container.getActor(originId).classType);
                const damageType = (0, Record_1.getValueOrDefault)(this.crystalDamages, originType, "Chaos");
                return {
                    originIdOverride: originId,
                    targetId: selectedEnemy,
                    path: "line",
                    type: (0, Record_1.getValueOrDefault)(this.crystalProjectiles, originType, "ArcaneBolt"),
                    damages: [
                        AbilityDamage_1.AbilityDamage.Focus(damageType, 30)
                    ]
                };
            })
        });
    }
};
JoltAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Jolt)
], JoltAbilityHandler);
exports.JoltAbilityHandler = JoltAbilityHandler;
